"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const initialData = {
    providerInformation: {},
    patientInformation: {},
    specimenInformation: {},
    insuranceInformation: {},
    labInformation: {},
    tests: [],
    diagnosis: [],
};
exports.default = initialData;
